module.exports = __webpack_public_path__ + "static/media/Minimize.6c89a79c.svg";